if (!customElements.get('pawce-story-tabs')) {
  customElements.define('pawce-story-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab.dataset.block);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        let index = this.tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        const next = this.tabs[(index + this.tabs.length) % this.tabs.length];
        this.select(next.dataset.block);
        next.focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.panels.some(panel => panel.dataset.block === event.detail.blockId)) this.select(event.detail.blockId);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    select(id) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.block === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.block !== id; });
    }
  });
}
